/**
 * Formats a number using Spanish locale (dots for thousands, commas for decimals)
 * @param {number|string} value - The number to format
 * @param {Object} options - Intl.NumberFormat options
 * @returns {string} Formatted number
 */
export const formatNumber = (value, options = {}) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '0';
  
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options
  }).format(num);
};

/**
 * Formats a number as currency (with $ sign)
 * @param {number|string} value - The number to format
 * @returns {string} Formatted currency
 */
export const formatCurrency = (value) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '$0';
  
  const hasDecimals = num % 1 !== 0;

  return `$${formatNumber(num, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2
  })}`;
};

export const formatPersonName = (value) => {
  if (!value || typeof value !== 'string') return '';

  return value
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((part) =>
      part
        .split('-')
        .map((segment) => {
          if (!segment) return segment;
          const normalized = segment.toLocaleLowerCase('es-AR');
          return normalized.charAt(0).toLocaleUpperCase('es-AR') + normalized.slice(1);
        })
        .join('-')
    )
    .join(' ');
};
